import { Box, Button, Container } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import LectureDetailComponent from '../../components/LectureDetail';

const colors = {
    text: '#1a1a1a',
    primary: '#005a8d',
    primaryDark: '#004870',
    primaryLight: '#f5f9fc',
    border: '#e7edf2',
    muted: '#555555',
};

function LectureDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Box sx={{ bgcolor: '#ffffff', color: colors.text, minHeight: '100vh' }}>
            <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#ffffff' }}>
                <Container maxWidth="xl">
                    <LectureDetailComponent lectureId={id} />
                    
                    <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/lecture')}
                            sx={{
                                px: 4,
                                py: 1.5,
                                fontWeight: 800,
                                color: colors.primary,
                                borderColor: colors.border,
                                borderRadius: 2,
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    borderColor: colors.primary,
                                    bgcolor: colors.primaryLight,
                                }
                            }}
                        >
                            목록으로 돌아가기
                        </Button>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
}

export default LectureDetailPage;
